import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const ArrowUpIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "ArrowUpIcon", ...props, ref: ref, viewBox: "0 0 14 16", children: _jsx("g", { children: _jsx("polyline", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: props.strokeWidth, points: "3 10 7 6 11 10" }) }) })));
ArrowUpIcon.displayName = "ArrowUpIcon";
